module.exports = __webpack_public_path__ + "static/media/vision.c3579726.jpg";